import { useApiContext } from "@contexts/ApiContext";
import { useHttp, type HttpConfiguration } from "@repo/utils/hooks";

type AppConfigData = { [key: string]: string | number | boolean };

export const AppConfigFile = {
  ENV: "env.json",
} as const;

export type AppConfigFile = (typeof AppConfigFile)[keyof typeof AppConfigFile];

export function useAppConfig<T extends AppConfigData>(
  key: AppConfigFile,
  options?: HttpConfiguration
) {
  const { base } = useApiContext();

  return useHttp(`/configs/${key}`, (url) => base.get(url).json<T>(), options);
}
